import { render, staticRenderFns } from "./CardFaq.vue?vue&type=template&id=406f739c&scoped=true&"
import script from "./CardFaq.vue?vue&type=script&lang=ts&"
export * from "./CardFaq.vue?vue&type=script&lang=ts&"
import style0 from "./CardFaq.vue?vue&type=style&index=0&id=406f739c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "406f739c",
  null
  
)

export default component.exports